<app-header [forceLightBackground]="true"></app-header>
<div class="org-admin-my-submissions">
  <div class="org-admin-my-submissions--layout">
    <app-org-admin-sidebar class="org-admin-my-submissions--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-my-submissions--content">
      <app-page-header></app-page-header>
      <div class="my-submissions--container">
        <app-my-submissions [showPanelHeader]="false"></app-my-submissions>
      </div>
    </div>
  </div>
</div>
